import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import { routesAPI, busesAPI } from '../../services/api';
import PaginatedTable from '../../components/PaginatedTable';

function RoutesManager() {
  const [routes, setRoutes] = useState([]);
  const [buses, setBuses] = useState([]);
  const [form, setForm] = useState({ route_name: '', description: '', bus_id: '' });
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const { t } = useI18n();

  const loadData = async () => {
    try {
      const [r, b] = await Promise.all([routesAPI.list(), busesAPI.list()]);
      setRoutes(r.data);
      setBuses(b.data);
    } catch (err) { setError('Failed to load data.'); }
  };

  useEffect(() => { loadData(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const payload = { ...form, bus_id: form.bus_id || null };
      if (editingId) {
        await routesAPI.update(editingId, payload);
      } else {
        await routesAPI.create(payload);
      }
      setForm({ route_name: '', description: '', bus_id: '' });
      setEditingId(null);
      loadData();
    } catch (err) {
      setError(err.response?.data?.error || 'Operation failed.');
    }
  };

  const handleEdit = (route) => {
    setEditingId(route.id);
    setForm({ route_name: route.route_name, description: route.description || '', bus_id: route.bus_id || '' });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Soft delete this route?')) return;
    try { await routesAPI.remove(id); loadData(); } catch (err) { setError('Delete failed.'); }
  };

  const columns = [
    { key: 'route_name', label: t('routeName') },
    { key: 'description', label: t('description') },
    { key: 'bus_number', label: t('assignedBus'), render: (v) => v || <span style={{ color: '#999' }}>{t('unassigned')}</span> },
  ];

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <Link to="/admin" style={{ color: '#007bff', textDecoration: 'none' }}>{t('backToDashboard')}</Link>
      <h1>{t('manageRoutes')}</h1>

      {error && <div style={{ background: '#fee', color: '#c00', padding: '10px', borderRadius: '4px', marginBottom: '15px' }}>{error}</div>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <input placeholder={t('routeNamePlaceholder')} value={form.route_name} onChange={(e) => setForm({...form, route_name: e.target.value})} required style={styles.input} />
        <input placeholder={t('descriptionPlaceholder')} value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} style={styles.input} />
        <select value={form.bus_id} onChange={(e) => setForm({...form, bus_id: e.target.value})} style={styles.input}>
          <option value="">{t('noBusAssigned')}</option>
          {buses.map((b) => <option key={b.id} value={b.id}>{b.bus_number} ({b.license_plate})</option>)}
        </select>
        <button type="submit" style={styles.saveBtn}>{editingId ? t('update') : t('create')}</button>
        {editingId && <button type="button" onClick={() => { setEditingId(null); setForm({ route_name: '', description: '', bus_id: '' }); }} style={styles.cancelBtn}>{t('cancel')}</button>}
      </form>

      <PaginatedTable data={routes} columns={columns} searchFields={['route_name', 'description', 'bus_number']} onEdit={handleEdit} onDelete={handleDelete} />
    </div>
  );
}

const styles = {
  form: { display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '8px' },
  input: { padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', minWidth: '150px' },
  saveBtn: { padding: '8px 16px', background: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  cancelBtn: { padding: '8px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
};

export default RoutesManager;
